var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 695,
    height: 695,
    viewBox: "0 0 695 695",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_732_368)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 347.274,
    cy: 347.272,
    r: 301.798,
    fill: "url(#paint0_linear_732_368)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_732_368",
    x: 0.476562,
    y: 0.474609,
    width: 693.594,
    height: 693.596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5,
    result: "effect1_foregroundBlur_732_368"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_732_368",
    x1: -71.2105,
    y1: 285.569,
    x2: 960.192,
    y2: 300.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#EB1E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A11692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A11692"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBg);
export default __webpack_public_path__ + "static/media/checkmark_bg.659986bd6195cdad2a57a086bbb6ddc8.svg";
export { ForwardRef as ReactComponent };